import SelectSeason from '../SelectSeason';

import {
  HOME_PATH,
  PANORAMA_LOGO_ALT,
  PANORAMA_LOGO_SRC,
  PANORAMA_TITLE
} from './constants';
import * as Styled from './styles';

type Props = {
  hideRegionSeasonSelector?: boolean;
  selectorGap?: number;
};

/**
 * Static top bar rendered while the remote `topbar-navigation` micro-frontend
 * is loading or unavailable (e.g. after a `remoteEntry.json` fetch failure).
 *
 * It mirrors the real top bar's branding and — because it renders inside the
 * app's provider tree — reuses the live `SelectSeason` control, so users keep a
 * working region/crop-season switcher instead of being dropped to the global
 * error screen. The deck-of-apps and profile menus are owned by the MFE and
 * are intentionally omitted rather than shown as dead controls.
 */
const TopbarFallback = ({
  hideRegionSeasonSelector = false,
  selectorGap = 20
}: Props) => (
  <Styled.Container>
    <Styled.Brand>
      <a href={HOME_PATH}>
        <Styled.Logo src={PANORAMA_LOGO_SRC} alt={PANORAMA_LOGO_ALT} />
      </a>
      <Styled.Divider />
      <Styled.Title>{PANORAMA_TITLE}</Styled.Title>
    </Styled.Brand>
    {!hideRegionSeasonSelector && (
      <Styled.Selectors $gap={selectorGap}>
        <SelectSeason />
      </Styled.Selectors>
    )}
  </Styled.Container>
);

export default TopbarFallback;
